import React from 'react';
import { Brain } from 'lucide-react';
import { createIframeGame } from './IframeGameActivity';

export default createIframeGame({
  id: 'memory-matrix',
  displayName: 'Memory Matrix',
  shortDescription: 'Single-player run · score to leaderboard.',
  leaderboard: 'score',
  url: 'https://memory-matrix.pages.dev/',
  icon: Brain,
  attribution: {
    text: 'Memory Matrix — MIT — github.com/Chimthuwu/Memory-Matrix',
    license: 'MIT',
    href: 'https://github.com/Chimthuwu/Memory-Matrix',
  },
});
